import React, { useState,useEffect }  from 'react'
import { Form,  Button,Modal } from 'antd';
import { renderInput, renderTextField } from '../../component/form/form';
import { connect } from 'react-redux';


import { updateUnitCost,getClientDetails } from '../../actions/clients';


  const tailLayout = {
    wrapperCol: { offset: 4, span: 16 },
  };

const EditUnit = ({visible, setVisible,user_id,updateUnitCost,getClientDetails,refresh}) => {
      
      const [data, setData] = useState(null)
     
      const [form] = Form.useForm();

      useEffect(async() => {

        const result = await getClientDetails(user_id);
        
        setData(result)

            form.setFieldsValue({
              unit_cost: result?.unit_cost
            });

      }, [])
    
      const onFinish = async (values) => {
        
        
        const code = await updateUnitCost(values, data.user_id)
        if(code === 201){
          refresh()
          setVisible()
        }
      };
    
      const onFinishFailed = (errorInfo) => {
        // console.log('Failed:', errorInfo);
      };
      

      
    return ( 
          
          <Modal
          title="Update Unit Cost"
          centered
          visible={visible}
          onOk={() => setVisible(false)}
          onCancel={() => setVisible(false)}
          width={1000}
        >
          {data ?
              <Form
              name="basic"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 16 }}
              initialValues={{ remember: true }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              style={{alignSelf: 'center'}}
              requiredMark={false}
              form={form}
              >
                
                {renderInput('unit_cost', 'Unit Cost', [
                    { required: true, message: 'This field is required!' },
                  ])
                }
                {renderTextField('remark', 'Remark', [
                  { required: true, message: 'This field is required!' },
                ])
              }
                
                
                <Form.Item {...tailLayout}> 
                  <Button type="primary" htmlType="submit">
                    Update
                  </Button>
                </Form.Item>
              
              </Form>
          :null}
        </Modal>
     );
}
 
export default connect(null,{updateUnitCost,getClientDetails})(EditUnit);
